import(/* webpackMode: "eager", webpackExports: ["LoginClient"] */ "/vercel/path0/web/app/(auth)/login/login-client.tsx");
